import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import Icon from './Icon';

class IconBlockStateDefinition implements BlockStateDefinition {
  getComponent() {
    return Icon;
  }

  get type(): ComponentTypeUnionType {
    return 'Icon';
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component, ['content', 'appearance', 'componentType']),
      }) as BlockStateUnionType;
  }
}

export default IconBlockStateDefinition;
